import { request } from "./request";

// 模型列表
function getModelList(data) {
    return request({
        url: '/web/model/selectList',
        method: 'POST',
        data: data
    })
}

//音乐生成
function getMusic(data) {
    return request({
        url: '/web/api/ai/generate',
        method: 'POST',
        data: data
    })
}

//音乐详情
function getMusicDetail(data) {
    return request({
        url: '/web/webUserGdataMusic/getWebUserGdataMusic',
        method: 'POST',
        data: data
    })
}

//生成记录列表
function getMusicList(data) {
    return request({
        url: '/web/webUserGdataMusic/selectListPage',
        method: 'POST',
        data: data
    })
}

//删除
function deleteMusic(data) {
    return request({
        url: '/web/webUserGdataMusic/delete',
        method: 'POST',
        data: data
    })
}

//获取任务情况
function getTask(params) {
    return request({
        url: '/web/api/ai/task',
        method: 'GET',
        params
    })
}

//token查询
function getTokenCnt(params) {
    return request({
        url: '/web/model/getModelRemainTokenCnt',
        method: 'GET',
        params
    })
}

//歌名修改
function updateTitle(data) {
    return request({
        url: '/web/webUserGdataMusic/updateTitle',
        method: 'POST',
        data
    })
}

//下载列表
function getDownloadList(data) {
    return request({
        url: '/web/webUserDownload/selectListPage',
        method: 'POST',
        data
    })
}

//下载接口
function getDownload(data) {
    return request({
        url: '/web/webUserDownload/webUserDownloadSave',
        method: 'POST',
        data
    })
}

//收藏列表
function getCollectList(data) {
    return request({
        url: '/web/webUserCollect/selectListPage',
        method: 'POST',
        data
    })
}

//收藏接口
function getCollect(data) {
    return request({
        url: '/web/webUserCollect/webUserCollectSave',
        method: 'POST',
        data
    })
}

//取消收藏
function getCollectDelete(data) {
    return request({
        url: '/web/webUserCollect/webUserCollectDelete',
        method: 'POST',
        data
    })
}

//生成中的数量
function getCountRunningTask(params) {
    return request({
        url: '/web/api/ai/countRunningTask',
        method: 'GET',
        params
    })
}




export default {
    getModelList,
    getMusic,
    getTask,
    getMusicList,
    getMusicDetail,
    deleteMusic,
    getTokenCnt,
    updateTitle,
    getDownloadList,
    getDownload,
    getCollectList,
    getCollect,
    getCollectDelete,
    getCountRunningTask
}